import { controls, grouped } from "../controls";
const apb_files = {
  label: "Apb Files",
  pageLabel: "Apb Files", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: false } },
  pageType: "history",
  formTabs:
  {
    allTabs: [
      { label: "General", uid: "general" },
      // { label: "Apb File Records", uid: "apb_file_records", fastpath: "apb_file_records" }
    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", label: "User" }),
    ...controls.oc({ tab: "filter", c: "User", placeHolder: "User Code", name: "APBFile-creator-user_code", fastpath: "users" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "APBFile-creator-user_display" }),
    ...controls.displayText({ tab: "filter", label: "Code" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "apb_file_code", width: "col-sm-4", maxlength: 100 }),
    ...controls.displayText({ tab: "filter", label: "File Name" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "apb_file_display", maxlength: 50 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", default: true, label: "Active", name: "apb_file_active" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Code", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "apb_file_code", width: "col-sm-4", maxlength: 100, isReadOnly: true }),
    ...controls.displayText({ tab: "general", label: "File Name", star: true }),
    ...controls.text({ tab: "general", placeHolder: "", isReadOnly: true, name: "apb_file_display", isRequired: true, maxlength: 50 }),

    // ...controls.displayText({ tab: "general", label: "" }),
    // ...controls.displayText({ tab: "apb_file_records", label: "Data", star: true }),
    // ...controls.text({ tab: "apb_file_records", placeHolder: "", name: "data", width: "col-sm-4", maxlength: 200, isReadOnly: "edit" }),

    ...controls.displayText({ tab: "general", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "general", width: "col-sm-2", label: "" }),
    // ...controls.button({
    //   tab: "apb_file_records",
    //   label: "ADD",
    //   style: { padding: 0 },
    //   Bcolor: "success",
    //   onclick: {
    //     action: "appendToHTMLTable",
    //     tableNameField: "apb_file_records",
    //     requiredField: ["data",],
    //     required: ["data",],
    //   }, width: "col-sm-2"
    // }),
    ...controls.FileUpload({
      isReadOnly: "edit",
      tab: "general",
      readFile: { purpose: "calamity_funds", targetTable: 'apb_file_records', type: 'csv', columns: ["data"], set_file_name: 'apb_file_display' },
      label: "Fileupload",
      name: "bulk_file_upload",
      placeholder: {
        type: "text",
        value: "Upload Bulk files"
      },
      width: "col-sm-10"
    }),
    {
      tab: "general",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Data", field: "data" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "apb_file_records"
    },
  ]
  , history: {
    perPage: 10,
    reportHeader: "Apb Files",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Createdat", accessor: "createdat", type: 'date' },
      { Header: "User", accessor: "APBFile-creator-user_display", },
      { Header: "Createdby", accessor: "createdby", },
      { Header: "Apb File Code", accessor: "apb_file_code", },
      { Header: "File Name", accessor: "apb_file_display", },
      { Header: "Apb File Active", accessor: "apb_file_active", type: 'tick' },
    ]
  }
};
export default apb_files;